import React from 'react';
import HostWizard from './HostWizardPage';

export default {
  path: '/host_wizard',
  render: props => <HostWizard {...props} />,
};



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/HostWizard/index.js